<template>
  <v-row justify="center" class="align-self-center">
    <v-col cols="12" sm="11">
      <v-alert v-if="errorMessages" type="error">{{ errorMessages }}</v-alert>
      <v-alert v-if="!this.$route.query.shop" type="error">The order shop is mising</v-alert>
    </v-col>
    <v-col v-if="this.$route.query.shop" cols="12" sm="5" md="5" lg="4" xl="4" class="form-wrapper">
      <v-card ref="form" class="form-init">
        <v-card-title text-center>{{ $t('Return form') }}</v-card-title>
        <v-card-text class="py-0">
          <v-text-field
            color="dark"
            v-model="email"
            :error-messages="emailErrors"
            v-bind:label="$t('E-mail/Phone')"
            required
            outlined
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
            @keypress.enter="searchTheOrder()"
          ></v-text-field>
          <v-text-field
            color="dark"
            v-model="order_nr"
            :error-messages="order_nrErrors"
            :counter="20"
            v-bind:label="$t('Order number')"
            required
            outlined
            @input="$v.order_nr.$touch()"
            @blur="$v.order_nr.$touch()"
            @keypress.enter="searchTheOrder()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" :dark="true" @click="searchTheOrder()">{{ $t('Search order') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-overlay :value="overlay" :color="'white'">
      <v-progress-circular indeterminate size="64" :color="'black'"></v-progress-circular>
    </v-overlay>
    <div v-if="themeJson.name === 'custom'">
      <div v-html="styles"></div>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
export default {
  mixins: [validationMixin],
  overlay: false,
  name: 'home',
  components: {},
  data() {
    return {
      errorMessages: null,
      overlay: false,
      email: '',
      order_nr: '',
      styles: '',
    };
  },
  validations: {
    email: { required, email },
    order_nr: { required },
  },
  created() {
    this.styles = this.getStyles();
  },
  mounted() {
    this.overlay = true;
  },
  computed: {
    ...mapState(['themeJson']),

    order_nrErrors() {
      const errors = [];
      if (!this.$v.order_nr.$dirty) return errors;
      !this.$v.order_nr.required && errors.push(this.$t('Order number is required'));
      return errors;
    },
    emailErrors() {
      const errors = [];
      // eslint-disable-next-line
      const MOBILEREG =
        // eslint-disable-next-line
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      const CONTAINS_LETTER = /[a-zA-Z]/g;

      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push(this.$t('E-mail or Phone number is required'));

      if (CONTAINS_LETTER.test(this.email)) {
        !this.$v.email.email && errors.push(this.$t('Email must be valid'));
      } else {
        !MOBILEREG.test(this.email) && errors.push(this.$t('Phone number must be valid'));
      }

      return errors;
    },
  },
  methods: {
    ...mapActions(['getOrder', 'setOrderNumber', 'setEmail', 'setPhoneNumber']),

    searchTheOrder() {
      this.$v.$touch();
      if (this.emailErrors == '' && this.order_nrErrors == '') {
        const CONTAINS_LETTER = /[a-zA-Z]/g;

        this.setPhoneNumber(null);
        this.setEmail(null);
        this.setOrderNumber(this.order_nr);
        CONTAINS_LETTER.test(this.email) ? this.setEmail(this.email) : this.setPhoneNumber(this.email);

        this.getOrder()
          .then(() => {
            this.$router.push('/order-products');
          })
          .catch(error => {
            if (!navigator.onLine) {
              this.errorMessages = this.$t('No network connection');
            } else {
              if (error.response.status === 401) {
                this.errorMessages = this.$t('UnAuthorized');
              } else if (error.response.status === 404) {
                this.errorMessages = this.$t("Can't find the order. Please verify your order's credentials");
              } else if (error.response.status === 405) {
                this.errorMessages = this.$t('API Route Method Not Allowed');
              } else if (error.response.status >= 500) {
                this.errorMessages = this.$t('Server Error');
              } else {
                if (error.response && error.response.data && error.response.data.message) {
                  this.errorMessages = this.$t(error.response.data.message);
                } else {
                  this.errorMessages = this.$t("Can't find the order. Please verify your order's credentials");
                }
              }
            }
          });
      }
    },
    getStyles() {
      const theme = this.themeJson;
      return `
      <style>
body.theme-custom .v-application {
    background-color: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .form-wrapper > .v-sheet.v-card {
    background-color: ${theme.backgroundColor} !important;
}

body.theme-custom .v-card__title {
    color: ${theme.textColor};
}

body.theme-custom .v-input input,
body.theme-custom .v-input textarea {
    color: ${theme.inputTextColor};
}

body.theme-custom .form-init .v-text-field fieldset {
      border: ${theme.inputBackgroundColor === '#ffffff' ? '#c9cccf !important' : 'unset'}
}

body.theme-custom .v-label,
body.theme-custom .v-counter {
    color: ${theme.textColor} !important;
}

body.theme-custom .v-text-field--solo > .v-input__control > .v-input__slot {
    background: ${theme.inputBackgroundColor} !important;
    border: none;
}

body.theme-custom .v-application .error--text {
      color: #ff5252 !important;
}

body.theme-custom .v-btn.v-btn--has-bg:not(.btn-anulat):not(.v-btn--back):not(.v-btn--disabled):not(.v-btn--return):not(.btn-change) {
    background: ${theme.changeBtnColor} !important;
    color: ${theme.btnTextColor} !important;
}

body.theme-custom .v-text-field.v-input--is-focused .v-input__slot {
    border: 1px solid ${theme.selectBorderColor} !important;
}

body.theme-custom .v-application--is-ltr .form-init fieldset {
    background: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .v-text-field .v-label {
    color: ${theme.textColor};
}

      </style>
    `;
    },
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 1000);
    },
  },
};
</script>

<style lang="scss">
.form-init {
  fieldset {
    background: #fff !important;
  }
  .v-text-field {
    fieldset {
      border: none !important;
    }
  }
  .v-text-field .v-label {
    color: #545954;
  }
  .v-label--active {
    top: 6px !important;
    left: -10px !important;
  }
}
.v-application {
  .v-main__wrap .v-sheet.v-card {
    margin: 80px 20px 100px;
  }
  .form-wrapper {
    max-width: 585px;
    width: 100%;
    flex: auto;
  }
  .error--text {
    .v-input__slot {
      border: 1px solid #ff5252 !important;
    }
  }
  .v-text-field__details {
    padding: 5px 0 10px !important;
    margin-top: 2px;
  }
  .v-application--is-ltr {
    fieldset {
      border-radius: 6px;
      border-color: transparent !important;
      background-color: #fff;
    }
    .v-text-field.v-input--is-label-active,
    .v-text-field.v-input--is-focused {
      .v-label {
        top: 4px !important;
      }
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: 1px solid #d7d7d7 !important;
      }
    }
  }
}
.v-sheet.v-card:not(.v-sheet--outlined):not(.dialog) {
  box-shadow: none;
  border-radius: 6px;
  padding: 20px 10px;
  background-color: #f9f8f8;
}
.v-input__control {
  position: relative;
}
.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: #fff !important;
  box-shadow: none !important;
  border: 1px solid #c9cccf;
  border-radius: 5px;
  height: 56px;
  margin: 0;
}
.v-card__title {
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 35px;
}
.v-counter {
  font-size: 16px;
  position: absolute;
  top: 23px;
  right: 24px;
}
.v-card__actions {
  padding: 0 16px;
}
.v-card__actions > .v-btn.v-btn {
  border-radius: 6px;
  height: 40px;
  padding: 0 14px;
}
.v-btn__content {
  text-transform: none;
  letter-spacing: 0;
  font-size: 16px;
  font-weight: 400;
}
.form-init {
  .v-text-field__details {
    padding: 0px 0 16px !important;
  }
}
//themes
.theme-blue {
  .v-application {
    background-color: #1b254e !important;
  }
  .form-wrapper > .v-sheet.v-card {
    background-color: #2a335b !important;
  }
  .v-card__title {
    color: #fff;
  }
  .v-input input,
  .v-input textarea {
    color: white;
  }
  .v-label,
  .v-counter {
    color: #a6aaba;
  }
  .v-application--is-ltr .form-init {
    fieldset {
      background: #1b254e !important;
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: none !important;
      }
    }
    .v-text-field .v-label {
      color: #fff;
    }
    .v-label--active {
      top: 6px !important;
      left: -10px !important;
    }
  }

  .v-text-field--solo > .v-input__control > .v-input__slot {
    background: #1b254e !important;
    border: none;
  }
  .v-text-field--outlined fieldset {
    border: none;
  }
  .v-btn.v-btn--has-bg:not(.btn-anulat):not(.btn-return):not(.v-btn--back):not(.v-btn--disabled):not(
      .v-btn--return
    ):not(.btn-change) {
    background: #f7d523 !important;
    color: #1b254e !important;
  }
  .v-application--is-ltr .v-text-field.v-input--is-focused .v-input__slot {
    border: 1px solid #f7d523 !important;
  }
}
.theme-light-green {
  .v-application {
    background-color: #d7e3d7 !important;
  }
  .form-wrapper > .v-sheet.v-card {
    background-color: #e2ede2 !important;
  }
  .v-card__title {
    color: #000;
  }
  .v-input input,
  .v-input textarea {
    color: #000;
  }
  .v-label,
  .v-counter {
    color: #545954;
  }
  .v-text-field--solo > .v-input__control > .v-input__slot {
    background: #d7e3d7 !important;
    border: none;
  }
  .v-text-field--outlined fieldset {
    border: none;
  }
  .v-text-field.v-input--is-focused {
    .v-input__slot {
      border: 1px solid #fff !important;
    }
  }
  .v-btn.v-btn--has-bg:not(.btn-anulat):not(.v-btn--back):not(.v-btn--disabled):not(.v-btn--return) {
    box-shadow: none;
    background: #8fc026 !important;
    color: #fff;
  }
  .v-application--is-ltr .form-init {
    fieldset {
      background: #d7e3d7 !important;
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: none !important;
      }
    }
    .v-text-field .v-label {
      color: #545954;
    }
    .v-label--active {
      top: 6px !important;
      left: -10px !important;
    }
  }
}
.theme-green {
  .v-application {
    background-color: #0a5133 !important;
  }
  .form-wrapper > .v-sheet.v-card {
    background-color: #2f6742;
  }
  .v-card__title {
    color: #fff;
  }
  .v-input input,
  .v-input textarea {
    color: #fff;
  }
  .v-label,
  .v-counter {
    color: #9fbbaf;
  }
  .v-text-field--solo > .v-input__control > .v-input__slot {
    background: #0a5133 !important;
    border: none;
  }
  .v-text-field--outlined fieldset {
    border: none;
  }
  .v-btn.v-btn--has-bg:not(.btn-anulat):not(.v-btn--back):not(.v-btn--disabled):not(.btn-change) {
    box-shadow: none;
    background: #f7d523 !important;
    color: #000;
  }
  .v-text-field.v-input--is-focused {
    .v-input__slot {
      border: 1px solid #dac525 !important;
    }
  }
  .v-application--is-ltr .form-init {
    fieldset {
      background: #0a5133 !important;
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: none !important;
      }
    }
    .v-text-field .v-label {
      color: #fff;
    }
    .v-label--active {
      top: 6px !important;
      left: -10px !important;
    }
  }
}
.theme-light-blue {
  .v-application {
    background-color: #e6eff7 !important;
  }
  .form-wrapper > .v-sheet.v-card {
    background-color: #f4f9fe !important;
  }
  .v-card__title {
    color: #000;
  }
  .v-input input,
  .v-input textarea {
    color: #000;
  }
  .v-label,
  .v-counter {
    color: #5a5d60;
  }
  .v-text-field--solo > .v-input__control > .v-input__slot {
    background: #e6eff7 !important;
    border: none;
  }
  .v-text-field--outlined fieldset {
    border: none;
  }
  .v-btn.v-btn--has-bg:not(.btn-anulat):not(.v-btn--back):not(.v-btn--disabled):not(.btn-change) {
    box-shadow: none;
    background: #39a0ff !important;
    color: #fff;
  }
  .v-text-field.v-input--is-focused {
    .v-input__slot {
      border: 1px solid #fff !important;
    }
  }
  .v-application--is-ltr .form-init {
    fieldset {
      background: #e6eff7 !important;
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: none !important;
      }
    }
    .v-text-field .v-label {
      color: #5a5d60;
    }
    .v-label--active {
      top: 6px !important;
      left: -10px !important;
    }
  }
}
.theme-dark {
  .v-application {
    background-color: #221f2e !important;
  }
  .form-wrapper > .v-sheet.v-card {
    background-color: #2e2b3f !important;
  }
  .v-card__title {
    color: #fff;
  }
  .v-input input,
  .v-input textarea {
    color: #fff;
  }
  .v-label,
  .v-counter {
    color: #a9a8ad;
  }
  .v-text-field--solo > .v-input__control > .v-input__slot {
    background: #221f2e !important;
    border: none;
  }
  .v-text-field--outlined fieldset {
    border: none;
  }
  .v-btn.v-btn--has-bg:not(.btn-return) {
    box-shadow: none;
    background: #f79123 !important;
    color: #fff;
  }
  .v-application .v-application--is-ltr .v-text-field.v-input--is-focused .v-input__slot {
    border-color: #d27f29 !important;
  }
  .second-tab .v-text-field .v-label {
    color: #fff !important;
    opacity: 0.48;
    top: 0px !important;
    left: 0px !important;
  }
  .v-text-field.v-input--is-focused {
    .v-input__slot {
      border: 1px solid #d27f29 !important;
    }
  }
  .v-text-field > .v-input__control > .v-input__slot:before,
  .v-text-field > .v-input__control > .v-input__slot:after {
    display: none;
  }
  .v-application--is-ltr .form-init {
    fieldset {
      background: #221f2e !important;
    }
    .v-text-field.v-input--is-focused {
      fieldset {
        border: none !important;
      }
    }
    .v-text-field .v-label {
      color: #fff;
    }
    .v-label--active {
      top: 6px !important;
      left: -10px !important;
    }
  }
}
</style>
